import { Component, ElementRef, OnInit, VERSION, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AlertService } from 'src/app/_alert';
import { AuthService } from 'src/app/_services/auth.service';
import { LoginService } from 'src/app/_services/login.service';
import { Country, State, City, IState, ICountry, ICity } from 'country-state-city';
import { getStatesOfCountry, getStateByCode } from 'country-state-city/lib/state';
import { ZipCodeService } from 'src/app/_services/zip-code.service';

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.css']
})
export class MyProfileComponent implements OnInit {

  constructor(
    private loginService: LoginService,
    private authService: AuthService,
    private zipCodeService: ZipCodeService,
    private alertService: AlertService
  ) {
    const countryCode = 'US'; // Country code for the USA
    this.State = getStatesOfCountry(countryCode);
  }

  State = [];
  City = [];

  utcStr = new Date().toUTCString();
  submitted: boolean = true;
  status: boolean = false;
  isLoading: boolean = false;
  // Country:[]
  token = this.authService.getToken()
  options = {
    autoClose: true,
    keepAfterRouteChange: true,
  };
  customerDetailRespone: any;
  updatedCustomerField: string[];

  fetchCities(stateCode: string) {
    const selectedState = this.State.find(state => state.isoCode === stateCode);
    this.City = selectedState?.getCities() || [];
  }

  ngOnInit(): void {
    // this.country()
    this.getData();
  }

  getData() {
    this.isLoading = true;
    this.loginService.profile('', '').subscribe((response) => {
      console.log("login response", response);
      this.myProfileForm.disable();

      this.customerDetailRespone = response;
      const mockEvent = {
        target: { value: response['zipCode'] }
      }
      this.onZipCodeChange(mockEvent);

      this.myProfileForm = new FormGroup(
        {
          CustomerId: new FormControl(this.authService.getRegistredUserDetails().customerId),
          UserId: new FormControl(response['userId']),
          FirstName: new FormControl(response['firstName'], [Validators.required]),
          Email: new FormControl(response['email'], [
            Validators.required,
            Validators.email,
            Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")
          ]),
          LastName: new FormControl(response['lastName'], [Validators.required]),
          organization: new FormControl(response['organization'], [Validators.required]),
          PhoneNumber: new FormControl(response['phoneNumber'], [
            Validators.required,
            Validators.pattern('^(\([0-9]{3}\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$')
          ]
          ),
          State: new FormControl(response['state'], [Validators.required]),
          Address: new FormControl(response['address'], [Validators.required]),
          Country: new FormControl('US'),
          ZipCode: new FormControl(response['zipCode'], [
            Validators.required,
            Validators.minLength(5),
            Validators.maxLength(5)
          ])
        })
      this.isLoading = false;
    }, (err) => {
      this.isLoading = false;
      console.log(err);
    });
    this.updatedCustomerField = [];
  }

  myProfileForm: FormGroup = new FormGroup(
    {
      CustomerId: new FormControl('', [Validators.required]),
      UserId: new FormControl('', [Validators.required]),
      FirstName: new FormControl('', [Validators.required]),
      Email: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")
      ]),
      LastName: new FormControl('', [Validators.required]),
      organization: new FormControl('', [Validators.required]),
      PhoneNumber: new FormControl('', [
        Validators.required,
        Validators.pattern('^(\([0-9]{3}\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$')
      ]),
      State: new FormControl('', [Validators.required]),
      Address: new FormControl('', [Validators.required]),
      Country: new FormControl('US'),
      ZipCode: new FormControl('', [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(5)
      ]),
      updatedFields: new FormControl(''),
    }
  )
  onFieldChange = function (value: string) {
    var fieldV = '';
    var originalV = '';
    var arrayKey = '';

    switch (value) {
      case 'fn':
        fieldV = this.myProfileForm.value.FirstName;
        originalV = this.customerDetailRespone['firstName'] !== null ? this.customerDetailRespone['firstName'] : "";
        arrayKey = "First Name";

        break;
      case 'email':
        fieldV = this.myProfileForm.value.Email;
        originalV = this.customerDetailRespone['email'] !== null ? this.customerDetailRespone['email'] : "";
        arrayKey = "Email";

        break;
      case 'zip':
        fieldV = this.myProfileForm.value.ZipCode;
        originalV = this.customerDetailRespone['zipCode'] !== null ? this.customerDetailRespone['zipCode'] : "";
        arrayKey = "Zip Code";

        break;
      case 'state':
        fieldV = this.myProfileForm.value.State;
        originalV = this.customerDetailRespone['state'] !== null ? this.customerDetailRespone['state'] : "";
        arrayKey = "State";

        break;
      case 'ln':
        fieldV = this.myProfileForm.LastName;
        originalV = this.customerDetailRespone['lastName'] !== null ? this.customerDetailRespone['lastName'] : "";
        arrayKey = "Last Name";

        break;
      case 'orgn':
        fieldV = this.myProfileForm.organization;
        originalV = this.customerDetailRespone['organization'] !== null ? this.customerDetailRespone['organization'] : "";
        arrayKey = "Organization";

        break;
      case 'address':
        fieldV = this.myProfileForm.Address;
        originalV = this.customerDetailRespone['address'] !== null ? this.customerDetailRespone['address'] : "";
        arrayKey = "Address";

        break;
      case 'phone':
        fieldV = this.myProfileForm.PhoneNumber;
        originalV = this.customerDetailRespone['phoneNumber'] !== null ? this.customerDetailRespone['phoneNumber'] : "";
        arrayKey = "Phone Number";

        break;
      default:
        break;
    }

    if (fieldV !== originalV) {
      if (this.updatedCustomerField.indexOf(arrayKey) === -1) {
        this.updatedCustomerField.push(arrayKey);
      }
    }
    else {
      if (this.updatedCustomerField.indexOf(arrayKey) !== -1) {
        var index = this.updatedCustomerField.indexOf(arrayKey);
        this.updatedCustomerField.splice(index, 1);
      }
    }
    console.log(this.updatedCustomerField);
  }

  onSubmit() {
    if (!this.status) {
      this.myProfileForm.enable();
      this.status = true;
    }
    else {
      this.submitted = true;
      this.isLoading = true;

      if (this.myProfileForm.valid) {
        
        this.myProfileForm.value.updatedFields=this.updatedCustomerField?.toString();

        this.loginService.updateProfile(this.myProfileForm.value, this.token).
          subscribe((updResponse) => {
            this.loginService.details(this.token)
            .subscribe((response: any) => {



            // var logo = this.authService.getRegistredUserDetails().logoFile
            // response['data'].logoFile = logo;
            this.authService.setRegistredUserDetails(response);
            //this.authService.setProfileDetails(response);
            console.log(response);
            this.alertService.success('Success!! Profile Updated SuccessFully.', this.options);
            this.myProfileForm.disable();
            this.status = false;
            setTimeout(() => {
              this.isLoading = false;
            }, 200);
          },
          (err) => {
            console.log(err);
            this.alertService.error(err.error.errors.Messages[0], this.options);
            this.isLoading = false;
          });
          },
            (err) => {
              console.log(err);
              this.alertService.error(err.error.errors.Messages[0], this.options);
              this.isLoading = false;
            })
      }
      else {
        console.log("Please enter valid details");
        // this.alertService.error('Error :( Please Enter Valid Details !', this.options);
        this.isLoading = false;
      }
    }
  }

  get forms() {
    return this.myProfileForm.controls;
  }

  reset() {
    this.myProfileForm.disable();
    this.status = false;
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  onPress(event) {
    const inputValue = event.target.value;
    const maxDigits = 11;
    if (event.target.value.length > 11) {
      const truncatedValue = inputValue?.slice(0, maxDigits);
      event.target.value = truncatedValue;
      this.myProfileForm.value.PhoneNumber = event.target.value
    }
  }
  onZipCodeChange(event) {
    var zip = event.target.value;
    this.City = [];
    this.State = [];
    if (zip == null || zip.length == 0 || zip.length < 5)
      return;
    this.zipCodeService.getDetailByZip(zip).subscribe((data: any) => {
      console.log(data);
      if (data == null||data?.length==0) {
        return;
      }
      this.City = data?.places?.map((place: any) => place['city']);
      this.State = data?.places?.map((place: any) => { return { 'state': place['state'], 'stateId': place['stateAbbreviation'] } });
    }, (err) => {
      console.log(err);
    });
  }
  // onZipCodeChange() {
  //   console.log('change');
  //   if (this.myProfileForm.value.ZipCode == null || this.myProfileForm.value.ZipCode.length == 0)
  //     return;
  //   this.zipCodeService.getDetailByZip(this.myProfileForm.value.ZipCode).subscribe((data: any) => {
  //     console.log(data);
  //     if (data == null) {
  //       return;
  //     }
  //     this.myProfileForm.patchValue({
  //       State: data.places[0].state
  //     });
  //   });
  // }
}


